import React from "react";
import "./styles.scss";

import UserInfo from "./UserInfo";
import Tabs from "./Tabs";
import { isSelfId, updateCurrentUserRedux, mapMediumtype } from "../../../../api/helper";
import { ReactComponent as EditIcon } from "../../../../public/icons/gray-white.svg";
import { createMedium } from "../../../../api/media";
import { updateCurrentUser } from "../../../../api/users";
import ImageUploader from "../../../shared/ImageUploader";

const changeCoverPhoto = async (s3_object_key, file) => {
  let {
    data: { medium },
  } = await createMedium({
    media: {
      type: mapMediumtype(file.type),
      s3_object_key,
    },
  });
  await updateCurrentUser({ user: { cover_image_id: medium.id } });
  updateCurrentUserRedux();
};

export default ({ user }) => {
  let backgroundStyle = {};
  if (user.cover_image && user.cover_image.type === "Image") backgroundStyle.backgroundImage = `url(${user.cover_image && user.cover_image.url})`;
  else backgroundStyle.backgroundColor = "#979797";

  return (
    <div className="profile-header" style={backgroundStyle}>
      <div className="inner">
        {user.cover_image && (user.cover_image.type === "Video" || user.cover_image.type === "DefaultCover") ? (
          <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop" className="inlineCoverVideo">
            <source src={user.cover_image.url} type="video/mp4" />
          </video>
        ) : null}

        {isSelfId(user.id) && (
          <div className="edit">
            <ImageUploader
              id="profile-banner"
              title="Add a Video or Photo to Your Header Banner"
              subtitle="(15 second max length is recommended for Videos)"
              onSubmit={changeCoverPhoto}
            >
              <EditIcon />
            </ImageUploader>
          </div>
        )}
        <div className="position-absolute blue-overlay"></div>
        <div className="position-absolute yellow-overlay"></div>
        <div className="overlay" />
        <UserInfo user={user} />
        <Tabs user={user} />
      </div>
    </div>
  );
};
